import React from "react";
import biswabangla from "../../assets/images/biswabangla.png";
import sudaImg from "../../assets/images/suda.jpeg";
import ulbImg from "../../assets/images/ULB.jpeg";
import apkImg from "../../assets/images/apkImg.png";
import { useNavigate } from "react-router-dom";

const roles = [
  { title: "SUDA", image: sudaImg, path: "/suda/login" },
  { title: "ULB", image: ulbImg, path: "/ulb/login" },
//   {
//     title: "DOWNLOAD APP",
//     image: apkImg,
//     path: "/download-app",
//     version: "1.0.2",
//     updatedAt: "05 Feb 2026, 02:45 PM",
//   },
];

const Landing = () => {
  const navigate = useNavigate();

  return (
    <div
      className="min-vh-100 d-flex flex-column align-items-center"
      style={{ backgroundColor: "#3e7ff6" }}
    >
      <div className="text-center text-white mt-4">
        <img src={biswabangla} alt="Logo" style={{ width: 130 }} />
        <h2
          className="fw-bold mt-3"
          style={{
            color: "white",
            opacity: 0.92,
            textShadow: "2px 4px 8px rgba(0,0,0,0.35)",
            letterSpacing: "0.5px",
          }}
        >
          Smart Urban Uniform Management System
        </h2>
        <h3 className="fw-semibold">(SUUMS)</h3>
      </div>

      <div className="container mt-5">
        <div className="row justify-content-center g-4">
          {roles.map((role, index) => (
            <div className="col-md-4" key={index}>
              <div
                className="card text-center h-100"
                onClick={() => {
                  if (role.title === "DOWNLOAD APP") {
                    window.location.href =
                      "https://sutmmg.codydeasoftech.in/public/uploads/ApK/SUUMS_V1.0.apk";
                  } else {
                    navigate(role.path);
                  }
                }}
                style={{
                  background: "rgba(255,255,255,0.95)",
                  borderRadius: "20px",
                  border: "1px solid rgba(255,255,255,0.4)",
                  backdropFilter: "blur(10px)",
                  boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
                  cursor: "pointer",
                  transition: "all 0.35s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform =
                    "translateY(-8px) scale(1.02)";
                  e.currentTarget.style.boxShadow =
                    "0 30px 60px rgba(0,0,0,0.25)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "none";
                  e.currentTarget.style.boxShadow =
                    "0 20px 40px rgba(0,0,0,0.15)";
                }}
              >
                <div className="card-body py-5">
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-4"
                    style={{
                      width: 130,
                      height: 130,
                      background: "linear-gradient(135deg, #ffffff, #e3f2fd)",
                      boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                      border: "4px solid #3e7ff6",
                      position: "relative",
                    }}
                  >
                    {role.title === "DOWNLOAD APP" && (
                      <div
                        style={{
                          position: "absolute",
                          width: "90px",
                          height: "90px",
                          borderRadius: "50%",
                          border: "4px solid white",
                          boxSizing: "border-box",
                          backgroundColor: "green",
                        }}
                      ></div>
                    )}

                    <img
                      src={role.image}
                      alt={role.title}
                      style={{
                        width: role.title === "DOWNLOAD APP" ? "60px" : "90px", // smaller for APK
                        height: role.title === "DOWNLOAD APP" ? "60px" : "90px",
                        objectFit: "contain",
                        position: "relative",
                        zIndex: 1,
                      }}
                    />
                  </div>

                  <h3
                    className="fw-bold"
                    style={{
                      color: "#1a237e",
                      letterSpacing: "1px",
                      marginTop: "10px",
                    }}
                  >
                    {role.title}
                  </h3>

                  {role.version ? (
                    <div style={{ marginTop: 8 }}>
                      <div style={{ fontSize: 18, color: "#000" }}>
                        Version {role.version}
                      </div>
                      <div style={{ fontSize: 13, color: "#333" }}>
                        Updated on {role.updatedAt}
                      </div>
                    </div>
                  ) : (
                    <div style={{ fontSize: 32, color: "black" }}>→</div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Landing;
